import React, { useState } from 'react';
import { Upload, Button, message, List, Space, Popconfirm } from 'antd';
import { UploadOutlined, DeleteOutlined, FileOutlined, DownloadOutlined } from '@ant-design/icons';
import api from '../../services/api';

const { Dragger } = Upload;

const AttachmentUpload = ({ contactId, attachments, onUploadSuccess, onDelete }) => {
  const [uploading, setUploading] = useState(false);

  const uploadProps = {
    name: 'file',
    multiple: false,
    customRequest: async ({ file, onSuccess, onError }) => {
      const formData = new FormData();
      formData.append('file', file);

      try {
        setUploading(true);
        const response = await api.post(
          `/attachments/contacts/${contactId}`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        if (response.data.success) {
          message.success('Fichier uploadé avec succès');
          onSuccess(response.data);
          onUploadSuccess && onUploadSuccess(response.data.data.attachment);
        } else {
          throw new Error(response.data.message);
        }
      } catch (error) {
        console.error('Upload error:', error);
        message.error('Erreur lors de l\'upload du fichier');
        onError(error);
      } finally {
        setUploading(false);
      }
    },
    showUploadList: false
  };

  const handleDownload = async (attachmentId, fileName) => {
    try {
      const response = await api.get(
        `/attachments/${attachmentId}/download`,
        {
          responseType: 'blob'
        }
      );

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download error:', error);
      message.error('Erreur lors du téléchargement');
    }
  };

  const handleDelete = async (attachmentId) => {
    try {
      const response = await api.delete(
        `/attachments/${attachmentId}`
      );

      if (response.data.success) {
        message.success('Fichier supprimé avec succès');
        onDelete && onDelete(attachmentId);
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      console.error('Delete error:', error);
      message.error('Erreur lors de la suppression du fichier');
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div>
      <Dragger {...uploadProps} style={{ marginBottom: 16 }}>
        <p className="ant-upload-drag-icon">
          <UploadOutlined />
        </p>
        <p className="ant-upload-text">Cliquez ou glissez-déposez un fichier ici</p>
        <p className="ant-upload-hint">
          Taille maximale: 10MB
        </p>
      </Dragger>

      {attachments && attachments.length > 0 && (
        <List
          header={<div>Fichiers joints ({attachments.length})</div>}
          dataSource={attachments}
          renderItem={(attachment) => (
            <List.Item
              actions={[
                <Button
                  key="download"
                  type="text"
                  icon={<DownloadOutlined />}
                  onClick={() => handleDownload(attachment.id, attachment.original_name)}
                >
                  Télécharger
                </Button>,
                <Popconfirm
                  key="delete"
                  title="Êtes-vous sûr de vouloir supprimer ce fichier ?"
                  onConfirm={() => handleDelete(attachment.id)}
                  okText="Oui"
                  cancelText="Non"
                >
                  <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                  >
                    Supprimer
                  </Button>
                </Popconfirm>
              ]}
            >
              <List.Item.Meta
                avatar={<FileOutlined />}
                title={attachment.original_name}
                description={formatFileSize(attachment.file_size)}
              />
            </List.Item>
          )}
        />
      )}
    </div>
  );
};

export default AttachmentUpload;
